import * as HLF from "html-living-framework";
import { Application } from "../../Application";
import * as Constants from "../../Data/Constants";
import * as SFX from "../../Data/SoundEffectKeys";
import { Obstacle } from "../../GameObjects/Obstacles/Obstacle";
import { BoxCollider } from "../../Physics/BoxCollider";
import { CompoundBoxCollider } from "../../Physics/CompoundBoxCollider";

export class Sputnik extends Obstacle {
    private static readonly SPEED: number = -50;
    private static readonly Y_RANGE: PIXI.Point = new PIXI.Point(-350, 50);
    private static readonly SCALE_MULT: number = 0.85;

    constructor() {
        const mult: number = Sputnik.SCALE_MULT;
        super(
            Sputnik.SPEED,
            new CompoundBoxCollider([
                new BoxCollider(5 * mult, 85 * mult, -50 * mult, 5 * mult),
                new BoxCollider(85 * mult, 130 * mult, -35 * mult, 70 * mult),
                new BoxCollider(130 * mult, 180 * mult, -65 * mult, 40 * mult),
            ]),
        );
        this._collisionSfx = SFX.IMPACT_SPUTNIK;

        this.position.y = HLF.Random.floatBetweenPoint(Sputnik.Y_RANGE);

        this._image = HLF.PixiUtils.makeSprite("sputnik", Constants.SPRITESHEET_OBSTACLE_PREFIX + "00");
        this._image.position.x = this._image.width * this._image.anchor.x;
        this._image.scale.set(Sputnik.SCALE_MULT);
        this.addChild(this._image);

        Application.instance.audio.play(SFX.SPUTNIK_ENTER, 1, false, HLF.AudioCategory.SFX);
    }

    public onCollision(pIsBalloonInvuln: boolean): void {
        super.onCollision(pIsBalloonInvuln);
        if (pIsBalloonInvuln) {
            this.playDeflectAnim();
        }
    }
}
